// extracted by mini-css-extract-plugin
export default {"ldsEllipsis":"loader_ldsEllipsis__GoxNS","ldsEllipsis1":"loader_ldsEllipsis1__yYZH0","ldsEllipsis2":"loader_ldsEllipsis2__vVaYG","ldsEllipsis3":"loader_ldsEllipsis3__RIgWj"};